package uz.ferro.erp.util

import kotlinx.datetime.Clock
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlin.js.Date

private fun parseDate(dateStr: String?): Date? {
    dateStr ?: return null
    return try {
        Date(dateStr)
    } catch (e: Exception) {
        null
    }
}

fun currentDateYMD(): String {
    val now = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault())
    return "${now.year}-${now.monthNumber.twoDigit()}-${now.dayOfMonth.twoDigit()}"
}

fun currentDateDMY(): String {
    val now = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault())
    return "${now.dayOfMonth.twoDigit()}-${now.monthNumber.twoDigit()}-${now.year}"
}

fun String?.formatDMY(): String {
    return this?.let {
        val parts = it.split("T")
        if (parts.isNotEmpty()) {
            val date = parts[0]
            date.split("-")
                .reversed()
                .joinToString("-")
        } else {
            it // Return the original string if no space is found
        }
    } ?: ""
}

fun String?.formatHMS(): String {
    return this?.let {
        val parts = it.split("T")
        if (parts.size >= 2) {
            val date = parts[1]
            date.split(":")
                .take(3)
                .joinToString(":") { part ->
                    part.take(2)
                }
        } else {
            it // Return the original string if no space is found
        }
    } ?: ""
}

fun formatInterval(startTime: String?, endTime: String?): String {
    val startDate = parseDate(startTime) ?: return ""
    val endDate = parseDate(endTime) ?: return ""

    val interval  = endDate.getTime() - startDate.getTime()
    val totalSeconds = interval.toInt() / 1000
    val hours = totalSeconds / 3600
    val minutes = (totalSeconds % 3600) / 60
    val seconds = totalSeconds % 60
    return "${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}"
}


fun String?.formatYMD(): String {
    return this?.let {
        val parts = it.split("T")
        if (parts.isNotEmpty()) {
            val date = parts[0]
            date.split("-")
                .joinToString("-")
        } else {
            it // Return the original string if no space is found
        }
    } ?: ""
}

fun getCurrentDateTimeSuffix(): String {
    val now = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault())
    val dateStr = "${now.year}-${now.monthNumber.twoDigit()}-${now.dayOfMonth.twoDigit()}"
    val timeStr = "${now.hour.twoDigit()}-${now.minute.twoDigit()}-${now.second.twoDigit()}"
    return "${dateStr}_${timeStr}"
}

private fun Int.twoDigit(): String {
    return this.toString().padStart(2, '0')
}